import { atom, useAtomValue, useAtom } from "jotai";
import { useNavigate } from "react-router";

interface IModelData {
  name: string;
  fields: any;
  required_fields: string[];
  relationships: any[];
}

interface ISingleItemData {
  name: string;
  fields: any;
  data: any;
}

interface IUserData {
  username: string;
  user_role: string;
  email: string;
  mfa_enabled?: boolean;
  mfa_verified?: boolean;
}

interface IHostData {
  frontend_url: string;
  frontend_port: number;
  backend_url: string;
  backend_port: number;
  aws_bucket: string;
  aws_region: string;
  s3_endpoints_path: string;
}

interface IGeneralData {
  supported_formats: Map<string, string[]>;
  multipart_chunk_size: number;
  maintenance_info: {
    start_time: Date;
    end_time: Date;
    message: string;
  } | null;
  enable_user_management: boolean;
  mfa_enabled: boolean;
}

const defaultModelData: IModelData[] = [];

const modelDataAtom = atom<IModelData[]>(defaultModelData);
const loginStatusAtom = atom<boolean>(false);
const userAtom = atom<IUserData | null>(null);
const hostDataAtom = atom<IHostData>({
  frontend_url: "localhost",
  frontend_port: 5000,
  backend_url: "localhost",
  backend_port: 8080,

  aws_bucket: "lightwell-test",
  aws_region: "ap-southeast-2",
  s3_endpoints_path: "endpoints-dev",
});
const generalDataAtom = atom<IGeneralData>({
  supported_formats: new Map<string, string[]>(),
  multipart_chunk_size: 5000000,
  maintenance_info: null,
  enable_user_management: false,
  mfa_enabled: true,
});
const uploadListAtom = atom<string[]>([]);

// Check model against model data - if not valid, redirect to error page
const useValidateModel = (stringToValidate: string) => {
  const navigate = useNavigate();
  const data = useAtomValue(modelDataAtom);
  if (
    !data.find((model) => {
      return model.name === stringToValidate;
    })
  )
    navigate("/m/error");
};

// Add uploading atom
/**
 * Utility for adding fieldId to upload list
 * @returns [addToList(fieldId), removeFromList(fieldId)]
 */
const useModifyUploadList = (fieldId: string): [() => void, () => void] => {
  const [uploadList, setUploadList] = useAtom(uploadListAtom);
  const addToList = () => setUploadList([...uploadList, fieldId]);
  const removeFromList = () => {
    const newList = uploadList.filter((field) => field !== fieldId);
    setUploadList(newList);
  };
  return [addToList, removeFromList];
};

export {
  loginStatusAtom,
  modelDataAtom,
  hostDataAtom,
  generalDataAtom,
  useValidateModel,
  userAtom,
  uploadListAtom,
  useModifyUploadList,
};
export type { IModelData };
